import { Row, Col } from 'antd';
import React, { useEffect, useState } from 'react';
import api from '../../../api';
import AddOrder from './AddOrder/AddOrder';
import Grid from './Grid/Grid';
import SlotsMatcher from './Grid/slots-matcher';

function OrderGrid({ trailId, date }) {
  const [orders, setOrders] = useState([]);
  const [grids, setGrids] = useState([]);
  const [slots, setSlots] = useState([]);
  const [trail, setTrail] = useState(null);

  const initGrid = async () => {
    // get orders
    const res = await api.getSlotsWithOrdersByDay(trailId, date);
    setSlots(res)
  }

  useEffect(() => {
      const init = async () => {
          // get trail
          const res = await api.findTrail(trailId);
          setTrail(res);

          initGrid();
      };
      init();
  }, []);
  
  useEffect(() => {
    if (!slots.length) return;

    // collect orders
    const  allOrders = [];
    slots.forEach(slot => {
      slot.orders.forEach(order => !allOrders.find(x => x.id === order.id) && allOrders.push(order));
    });

    setOrders(allOrders);
  }, [slots])

  
  useEffect(() => {
    const createGrid = () => {
      if (!trail) return ;
      if (!slots.length) return ;
  
      const firstSlot = slots.length ? slots[0] : {};
      const lastSlot = slots.length ? slots[slots.length - 1] : {};
  
      const matcher = new SlotsMatcher(slots, trail, firstSlot, lastSlot);
      const gridsCollection = matcher.match();
      
      setGrids(gridsCollection);
    }

    createGrid();
    window.addEventListener('resize', createGrid);
  }, [trail, orders, slots]);
 

  return (<>
    <Row>
      <Col md={12}>
        <div className="legend">
          <i className="fa fa-circle started"></i> Nieopłacone <br/>
          <i className="fa fa-circle completed"></i> Opłacone <br/>
          {/* <i className="fa fa-circle paid"></i> Opłacone <br/> */}
          {/* <i className="fa fa-laptop"></i> Dodane przez panel */}
        </div>
        <hr></hr>
      </Col>
      <Col md={12} style={{ textAlign: 'right' }}>
        <AddOrder
          trailId={trailId}
          afterAdd={async order => {
            // get orders
            initGrid();

            // open order modal
            setTimeout(() => {
              const cell = document.querySelector(`[data-order-id="${order.id}"]`);
              if (cell) cell.click();
            }, 1000);
          }}
        />
      </Col>
    </Row>

    
    {grids.map((grid, i) => <Grid key={i} {...grid} timeSlots={slots} onChange={() => initGrid()} />)}
  </>);
}

export default OrderGrid;